<template>
  <div>
    <v-alert
      v-if="isErrorState && !retryableError"
      role="alert"
      type="error"
      :value="error"
      icon="error" 
      dense
      class="mb-4"
    >{{ error }}</v-alert>

    <template v-if="creatingUser">
      <loading :message="$t('REGISTRATION_LOADING_MESSAGE')"/>
    </template>

    <div v-else class="elevation-0">
      <h1>{{$t('REGISTRATION_COURSE_REGISTRATION')}}</h1>
        <v-alert
          v-if="error && retryableError"
          roler="alert"
          type="error"
          icon="error" 
          :value="!!error"
          class="mb-4"
          dense
        >{{ error }}</v-alert>

        <announcement/>

        <template v-if="course.courseName">
          <p
            class="mt-3 mb-3"
            v-html="$t('REGISTRATION_CONFIRM_MESSAGE',{course: course.courseName})"
          ></p>

          <login-buttons
            v-if="isValidCourseCode || true"
            :providers="['google', 'azure']"
            mode="registration"
            transition="fade-transition"
            @confirm="onLoginSuccess"
          />
        </template>

        <template v-else>
          <p class="mt-3 mb-3">{{$t('REGISTRATION_INSTRUCTIONS')}}</p>
          <v-flex xs12>
            <v-text-field
              :label="$t('INVITATION_CODE_LABEL')"
              v-model="courseCode"
              :required="true"
              :disabled="loading"
              @input="onCourseCodeChange"
            />
          </v-flex>
          <div v-if="loading" class="text-xs-center">
            <loading message="Validating"/>
          </div>
        </template>

        <router-link :to="{name:'login'}">
          {{
          $t("REGISTRATION_ALREADY_REGISTERED")
          }}
        </router-link>
      </div>
  </div>
</template>


<script lang="ts">
import Vue from 'vue';
import { setTimeout } from 'timers';
import Loading from '@utils/Loading.vue';
import LoginButtons from '../login/LoginButtons.vue';
import ErrorText from '@utils/ErrorText.vue';
import Announcement from '@utils/Announcement.vue';
import Component from 'vue-class-component';
import Config from '../../config';
import AddUserMethod from '@/interfaces/addUserMethod';
import { CreateUserParams } from '@/utils/userCreation/createUserParams';
import { useErrorStore } from "@/stores/errorStore";
import { useApiClientStore } from "@/stores/apiClientStore";
import { useAuthenticationStore } from "@/stores/authenticationStore";
import { useUserStore } from "@/stores/userStore";
import { storeToRefs } from "pinia";

@Component({
	components: { Loading, LoginButtons, ErrorText, Announcement }
})
export default class Registration extends Vue {
  get userApiClient() { return useApiClientStore().userApiClient; }
  get loading() { return useApiClientStore().isLoading; }
  getSsoToken = () => useAuthenticationStore().getSsoToken();
  tryLogin = () => useAuthenticationStore().tryLogin();

	// TODO: Change to composition api
	error = storeToRefs(useErrorStore()).errorMessage;
	// END TODO

	isErrorState: boolean = false;
	course = {};
	courseCode = '';
	retryableError: boolean = true;
	courseCodeIcon = undefined;
  creatingUser = false;
  
	get isValidCourseCode() {
		return this.courseCode.length === 12
	}

	async created() {
		if(this.$route.params.cid){
      this.courseCode = this.$route.params.cid;
      const validatedCode = await this.userApiClient.getCourseCode(this.courseCode);
      this.course = { courseName: validatedCode.courseName };
    }
	}

  destroyed()
  {
    useErrorStore().resetError();
  }

	async onCourseCodeChange() {
		if (this.courseCode.length === 12) {
			this.course = await this.userApiClient.getCourseCode(this.courseCode);
			useErrorStore().resetError();
		} else {
			if (this.courseCode.length < 12) useErrorStore().resetError();
		}
	}
  async onLoginSuccess() {
    try
    {
      this.creatingUser = true;
      await useUserStore().createUser(new CreateUserParams(AddUserMethod.courseCode, this.courseCode));
    }
    catch
    {
      this.creatingUser = false;
    }
	}
}
</script>
